/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_ICON = exports.CALENDAR_ICON = void 0;
var _react = _interopRequireDefault(require("react"));
var CLEAR_ICON = _react.default.createElement("svg", {
  height: "10",
  width: "10",
  viewBox: "4 4 16 16"
}, _react.default.createElement("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
}));
exports.CLEAR_ICON = CLEAR_ICON;
var CALENDAR_ICON = _react.default.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, _react.default.createElement("g", {
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  fillRule: "nonzero",
  d: "M8.304 13.527H6.17l2.327-4.72H5.538V7.384h4.914v.95l-2.148 5.192zM4.308 3.077c-.34 0-.616-.276-.616-.615V.615c0-.339.277-.615.616-.615.339 0 .615.276.615.615v1.847c0 .339-.276.615-.615.615z"
}), _react.default.createElement("path", {
  fillRule: "nonzero",
  d: "M14.154 1.23h-1.23v1.232c0 .679-.552 1.23-1.232 1.23-.68 0-1.23-.551-1.23-1.23V1.23H5.538v1.23c0 .68-.55 1.231-1.23 1.231-.68 0-1.231-.551-1.231-1.23V1.23h-1.23C.826 1.23 0 2.058 0 3.077v11.077C0 15.173.827 16 1.846 16h12.308C15.173 16 16 15.173 16 14.154V3.077c0-1.02-.827-1.846-1.846-1.846zm.615 12.924c0 .339-.276.615-.615.615H1.846c-.339 0-.615-.276-.615-.615V5.538h13.538v8.616z"
}), _react.default.createElement("path", {
  d: "M11.692 3.077c-.339 0-.615-.276-.615-.615V.615c0-.339.276-.615.615-.615.34 0 .616.276.616.615v1.847c0 .339-.277.615-.616.615z"
})));
exports.CALENDAR_ICON = CALENDAR_ICON;